// Lógica pura para precargar (prefill) el cuestionario médico.
//
// El backend (`api_get_survey_question` → `answers`) devuelve un mapa keyado por
// question id con el formato de `survey.user_input.line.get_model_data`:
//   - simple_choice / multiple_choice (answer_type 'suggestion'):
//       { answer: ['Texto'], answer_ids: [optionId, ...] }
//   - char_box / text_box / date / datetime:
//       { answer: 'string' }
//   - numerical_box:
//       { answer: 12.0 }
//
// Esta función lo traduce al shape del estado `answers` de SurveyFlow para que,
// al volver a entrar, el usuario vea sus respuestas y no tenga que repetirlas.

const emptyAnswer = () => ({
  value_str: null,
  value_int: null,
  value_options: [],
  selectedOptionId: null,
  selectedOptionIds: null,
  files: []
});

/**
 * @param {object} answersMap – mapa { questionId: savedLine } del backend
 * @param {Array}  questions  – preguntas (shape get_model_data) para resolver el tipo
 * @returns {object} estado `answers` parcial keyado por questionId
 */
export const mapSavedAnswersToState = (answersMap = {}, questions = []) => {
  const byId = {};
  (questions || []).forEach(q => {
    if (q && q.id != null) byId[q.id] = q;
    // las preguntas condicionales (triggering) también pueden tener respuesta guardada
    (q?.triggering_questions || []).forEach(tq => {
      if (tq && tq.id != null) byId[tq.id] = tq;
    });
  });

  const state = {};
  Object.entries(answersMap || {}).forEach(([qid, saved]) => {
    if (!saved) return;
    const id = Number(qid);
    const type = byId[id]?.question_type || saved.answer_type;

    if (type === 'simple_choice') {
      const optId = (saved.answer_ids || [])[0];
      if (optId == null) return;
      state[id] = { ...emptyAnswer(), value_options: [optId], selectedOptionId: optId };
    } else if (type === 'multiple_choice') {
      const ids = (saved.answer_ids || []).filter(v => v != null);
      if (ids.length === 0) return;
      state[id] = { ...emptyAnswer(), value_options: ids, selectedOptionIds: ids };
    } else if (type === 'numerical_box') {
      let val = Array.isArray(saved.answer) ? saved.answer[0] : saved.answer;
      if (val == null || val === '') return;
      state[id] = { ...emptyAnswer(), value_int: Number(val) };
    } else {
      // char_box, text_box, date, datetime
      let val = Array.isArray(saved.answer) ? saved.answer[0] : saved.answer;
      if (val == null) return;
      val = String(val).trim();
      if (val === '' || val === '0.0') return;
      state[id] = { ...emptyAnswer(), value_str: val };
    }
  });

  return state;
};
